import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { ViewportService } from "../services/viewport.service";

/** Blocks routes that are not usable on mobile web (e.g. Create/Revise Project), redirecting to a desktop-only notice. */
export const desktopOnlyGuard: CanActivateFn = (route) => {
  const viewport = inject(ViewportService);
  const router = inject(Router);

  if (!viewport.isMobile()) return true;

  const businessId = route.params["businessId"] || route.parent?.params["businessId"] || route.parent?.parent?.params["businessId"];

  return router.createUrlTree(["/", businessId, "projects", "desktop-only"]);
};
